import React from 'react';
import './linearScore.scss';
import { If } from 'common/src/components';

interface IProps {
    score: number;
    fullScore: number;
}

const FULL_SCORE = 5;

/**
 * 一维、二维时显示的单一线性图
 */
export function LinearScore(props: IProps) {
    const { score, fullScore = FULL_SCORE } = props;

    const width = (score / fullScore) * 100;

    const renderGoldMedal = () => {
        return (
            <div className="medal gold-medal">
                <div className="score">{score}</div>
            </div>
        );
    };

    const renderMedal = () => {
        return <div className="medal normal-medal"></div>;
    };

    return (
        <div className="linear-bar">
            <div className="inner-bar bg" style={{ width: `${width}%` }}>
                <If condition={width > 0}>{renderGoldMedal()}</If>
                <If condition={width === 0}>{renderMedal()}</If>
            </div>
        </div>
    );
}
